import { defineMessages } from 'react-intl';

export default defineMessages({
    Actions: {
        id: 'quoteandbind.pup.views.pup-location-exposures.Actions',
        defaultMessage: 'Actions'
    },
    AddLocation: {
        id: 'quoteandbind.pup.views.pup-location-exposures.Add Location',
        defaultMessage: 'Add Location'
    },
    AddLocationPopupHeader: {
        id: 'quoteandbind.pup.views.pup-location-exposures.Add a Location',
        defaultMessage: 'Add a Location'
    },
    EditLocationPopupHeader: {
        id: 'quoteandbind.pup.views.pup-location-exposures.Edit a Location',
        defaultMessage: 'Edit a Location'
    },
    LocationHeader: {
        id: 'common.directives.templates.ml-pup-locations-exposures.Locations',
        defaultMessage: 'Locations'
    },
    DateOfBirth: {
        id: 'quoteandbind.pup.views.pup-location-exposures.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    TYPE: {
        id: 'quoteandbind.pup.views.pup-location-exposures.TYPE',
        defaultMessage: 'TYPE'
    },
    CITY: {
        id: 'quoteandbind.pup.views.pup-location-exposures.CITY',
        defaultMessage: 'CITY'
    },
    STATE: {
        id: 'quoteandbind.pup.views.pup-location-exposures.STATE',
        defaultMessage: 'STATE'
    },
    ADDRESS: {
        id: 'quoteandbind.pup.views.pup-location-exposures.ADDRESS',
        defaultMessage: 'ADDRESS'
    },
    EXCLUDED: {
        id: 'quoteandbind.pup.views.pup-location-exposures.EXCLUDED',
        defaultMessage: 'EXCLUDED'
    },
    yes: {
        id: 'quoteandbind.pup.views.pup-location-exposures.yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'quoteandbind.pup.views.pup-location-exposures.no',
        defaultMessage: 'No'
    },
    itemHasBeenAdded: {
        id: 'quoteandbind.pup.views.pup-location-exposures.item has been added',
        defaultMessage: '<strong>{item}</strong> has been added.'
    },
    itemHasBeenRemoved: {
        id: 'quoteandbind.pup.views.pup-location-exposures.item has been removed',
        defaultMessage: '<strong>{item}</strong> has been removed. <a>Undo</a>'
    },
    itemNeedsAttention: {
        id: 'quoteandbind.pup.views.pup-location-exposures.itemNeedsAttention',
        defaultMessage: '<strong>{item} marked with (!) need your attention.</strong> please click the edit link and fill out the required fields.'
    },
    itemMayNotBeRemoved:{
        id:'quoteandbind.pup.views.pup-location-exposures.This location may not be removed',
        defaultMessage:'This location may not be removed. Please add an exclusion if you do not wish to cover this location.'
    },
    LocationModalSubtitle: {
        id: 'quoteandbind.pup.views.pup-location-exposures.Location Modal Subtitle',
        defaultMessage: 'Enter your location details'
    },
    LocationParagraph:{
        id:'quoteandbind.pup.views.pup-location-exposures.No Information Exists',
        defaultMessage:'No Information Exists'
    }
});

